import { configureStore } from '@reduxjs/toolkit'
import { loginReducer } from '@/modules/security/login/store/loginSlice/loginSlice.ts'
import { userReducer } from '@/modules/settings/users/store/userSlice/userSlice.ts'
import { globalReducer } from '@/globalStore/globalSlice/globalSlice.ts'
import { recoveryReducer } from '@/modules/security/passwordRecovery/store/recoverySlice/recoverySlice.ts'
import { setPasswordReducer } from '@/modules/utilities/setPassword/store/setPasswordSlice/setPasswordSlice.ts'
import { clientReducer } from '@/modules/sales/clients/store/clientSlice/clientSlice.ts'
import { calculatorReducer } from '../modules/utilities/calculator/store/calculatorSlice/calculatorSlice.ts'
import { uninstallAppReducer } from '../modules/utilities/uninstallApp/store/uninstallAppSlice/UninstallAppSlice.ts'
import { brandsReducer } from '@/modules/settings/brands/store/BrandsSlice.ts'
import { modelReducer } from '@/modules/settings/brands/store/ModelSlice.ts'
import { rentabilitiesReducer } from '@/modules/settings/tasa/store/RentabilitySlice.ts'
import { rolesReducer } from '@/modules/settings/roles/store/RoleSlice.ts'
import { functionalitiesReducer } from '@/modules/settings/roles/store/FunctionalitiesSlice.ts'
import { requestReducer } from '@/modules/support/store/requestSlice/requestSlice.ts'
import { alliesReducer } from '@/modules/allies/allies/store/allySlice/allySlice.ts'
import { branchOfficesReducer } from '@/modules/allies/allies/store/branchOfficeSlice/branchOfficeSlice.ts'
import { bankAccountReducer } from '@/modules/allies/allies/store/bankAccountSlice/bankAccountSlice.ts'
import { commissionsByProductTypeReducer } from '@/modules/allies/allies/store/commissionsByProductTypeSlice/commissionsByProductTypeSlice.ts'
import { tradeMarkReducer } from '@/modules/allies/allies/store/tradeMarkSlice/tradeMarkSlice.ts'
import { pendingRechargeReducer } from '@/modules/collections/pendingRecharges/store/pendingRechargeSlice/pendingRechargeSlice.ts'
import { promotionsReducer } from '@/modules/settings/promotions/store/PromotionSlice.ts'
import { paymentMethodsReducer } from '@/modules/settings/paymentMethod/store/PaymentMethodSlice.ts'
import { banksReducer } from '@/modules/settings/bank/store/BankSlice.ts'
import { levelsReducer } from '@/modules/settings/levels/store/LevelSlice.ts'
import { lateQuotaReducer } from '@/modules/collections/lateQuotas/store/lateQuotaSlice/lateQuotaSlice.ts'
import { inventoryApplesReducer } from '@/modules/inventory/inventoryApple/store/InventoryAppleSlice.ts'
import { inventoryAutomotivesReducer } from '@/modules/inventory/inventoryAutomotive/store/InventoryAutomotiveSlice.ts'
import { paymentRequestReducer } from '@/modules/allies/paymentRequests/store/paymentRequestSlice/paymentRequestSlice.ts'
import { dailyCutReducer } from '@/modules/allies/dailyCut/store/dailyCutSlice/dailyCutSlice.ts'
import { monthlyCutReducer } from '@/modules/allies/monthlyCut/store/monthlyCutSlice/monthlyCutSlice.ts'
import { inventoryProductsReducer } from '@/modules/inventory/inventoryProduct/store/InventoryProductSlice.ts'
import { videoCategoryReducer } from '@/modules/teaching/videosCategory/store/VideoCategorySlice.ts'
import { videoReducer } from '@/modules/teaching/videos/store/VideoSlice.ts'
import { paymentHistoryReducer } from '@/modules/allies/dailyCut/store/paymentHistorySlice/paymentHistorySlice.ts'
import { categoryReducer } from '@/modules/settings/categories/store/categorySlice/categorySlice.ts'
import { walletReducer } from '@/modules/allies/allies/store/walletSlice/walletSlice.ts'
import { cityReducer } from '@/modules/settings/localization/store/citySlice.ts'
import { sectorReducer } from '@/modules/settings/localization/store/sectorSlice.ts'
import { stateReducer } from '@/modules/settings/localization/store/stateSlice.ts'
import { payAllReducer } from '@/modules/services/payAll/store/payAllSlice/payAllSlice.ts'
import { dailyCutReducer as servicesDailyCutReducer } from '@/modules/services/dailyCut/store/dailyCutSlice/dailyCutSlice.ts'
import { dailyCutDetailReducer } from '@/modules/services/dailyCut/store/dailyCutDetailsSlice/dailyCutSlice.ts'
import { geolocationClientsReducer } from '@/modules/reports/geolocation/store/clientsSlice/geolocationClientsSlice.ts'
import { geolocationBranchOfficesReducer } from '@/modules/reports/geolocation/store/branchOfficesSlice/geolocationBranchOfficesSlice.ts'
import { geolocationUsersReducer } from '@/modules/reports/geolocation/store/usersSlice/geolocationUsersSlice.ts'
import { serviceCenterReducer } from '@/modules/insurers/serviceCenters/store/serviceCenterSlice/serviceCenterSlice.ts'
import { insuranceRentabilityReducer } from '@/modules/insurers/insuranceRentability/store/insuranceRentabilitySlice/insuranceRentabilitySlice.ts'
import { claimReducer } from '@/modules/insurers/claims/store/claimSlice/claimSlice.ts'
import { serviceRechargeInvoicesReducer } from '@/modules/sales/serviceRechargeInvoices/store/serviceRechargeInvoicesSlice/serviceRechargeInvoicesSlice.ts'
import { marketplaceOrdersReducer } from '@/modules/marketplace/orders/store/MarketplaceOrdersSlice.ts'
import { marketplaceReducer } from '@/modules/marketplace/marketplaces/store/marketplaceSlice/marketplaceSlice.ts'
import { marketplaceProductReducer } from '@/modules/marketplace/products/store/productSlice/productSlice.ts'
import { marketplaceInventoryReducer } from '@/modules/marketplace/inventory/store/inventorySlice/inventorySlice.ts'
import { marketplaceDiscountReducer } from '@/modules/marketplace/discounts/store/discountSlice/discountSlice.ts'
import { publicityReducer } from '@/modules/settings/publicity/store/publicitySlice/publicitySlice.ts'
import { campaignReducer } from '@/modules/draw/campaigns/store/campaignSlice/campaignSlice.ts'
import { drawReducer } from '@/modules/draw/draws/store/drawSlice/drawSlice.ts'

const store = configureStore({
  reducer: {
    global: globalReducer,
    login: loginReducer,
    recovery: recoveryReducer,
    users: userReducer,
    setPassword: setPasswordReducer,
    clients: clientReducer,
    calculator: calculatorReducer,
    uninstallApp: uninstallAppReducer,
    brands: brandsReducer,
    models: modelReducer,
    rentabilities: rentabilitiesReducer,
    roles: rolesReducer,
    functionalities: functionalitiesReducer,
    request: requestReducer,
    allies: alliesReducer,
    branchOffices: branchOfficesReducer,
    bankAccount: bankAccountReducer,
    commissionsByProductType: commissionsByProductTypeReducer,
    tradeMark: tradeMarkReducer,
    pendingRecharge: pendingRechargeReducer,
    promotions: promotionsReducer,
    paymentMethods: paymentMethodsReducer,
    banks: banksReducer,
    levels: levelsReducer,
    lateQuota: lateQuotaReducer,
    inventoryApple: inventoryApplesReducer,
    inventoryAutomotive: inventoryAutomotivesReducer,
    paymentRequest: paymentRequestReducer,
    dailyCut: dailyCutReducer,
    monthlyCut: monthlyCutReducer,
    inventoryProduct: inventoryProductsReducer,
    videoCategory: videoCategoryReducer,
    videos: videoReducer,
    paymentHistory: paymentHistoryReducer,
    categories: categoryReducer,
    wallet: walletReducer,
    city: cityReducer,
    sector: sectorReducer,
    state: stateReducer,
    payAll: payAllReducer,
    servicesDailyCut: servicesDailyCutReducer,
    servicesDailyCutDetail: dailyCutDetailReducer,
    geolocationClients: geolocationClientsReducer,
    geolocationUsers: geolocationUsersReducer,
    geolocationBranchOffices: geolocationBranchOfficesReducer,
    serviceCenter: serviceCenterReducer,
    insuranceRentability: insuranceRentabilityReducer,
    claim: claimReducer,
    serviceRechargeInvoices: serviceRechargeInvoicesReducer,
    marketplaceOrders: marketplaceOrdersReducer,
    marketplaces: marketplaceReducer,
    marketplaceProducts: marketplaceProductReducer,
    marketplaceInventory: marketplaceInventoryReducer,
    marketplaceDiscounts: marketplaceDiscountReducer,
    publicity: publicityReducer,
    campaigns: campaignReducer,
    draws: drawReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
